import { produce } from "immer";
import {
  GET_RESIDENT_SUMMARIES,
  GET_RESIDENT_SUMMARIES_SUCCESS,
  GET_RESIDENT_SUMMARIES_FAILURE,
  GET_RESIDENT_SUMMARY_DETAIL,
  GET_RESIDENT_SUMMARY_DETAIL_SUCCESS,
  GET_RESIDENT_SUMMARY_DETAIL_FAILURE,
  SAVE_SUMMARY_ANNOTATION,
  SAVE_SUMMARY_ANNOTATION_SUCCESS,
  SAVE_SUMMARY_ANNOTATION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingSummaries: false,
  summaries: [],
  summaryMeta: {},
  isFetchingSummaryDetail: false,
  summaryDetail: null,
  isSavingAnnotation: false,
};

const ResidentSummaryReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_RESIDENT_SUMMARIES:
        draft.isFetchingSummaries = true;
        break;
      case GET_RESIDENT_SUMMARIES_SUCCESS:
        draft.isFetchingSummaries = false;
        draft.summaries = action.payload?.data || [];
        draft.summaryMeta = action.payload?.meta || {};
        break;
      case GET_RESIDENT_SUMMARIES_FAILURE:
        draft.isFetchingSummaries = false;
        draft.summaries = [];
        break;

      case GET_RESIDENT_SUMMARY_DETAIL:
        draft.isFetchingSummaryDetail = true;
        draft.summaryDetail = null;
        break;
      case GET_RESIDENT_SUMMARY_DETAIL_SUCCESS:
        draft.isFetchingSummaryDetail = false;
        draft.summaryDetail = action.payload?.data || action.payload;
        break;
      case GET_RESIDENT_SUMMARY_DETAIL_FAILURE:
        draft.isFetchingSummaryDetail = false;
        draft.summaryDetail = null;
        break;

      case SAVE_SUMMARY_ANNOTATION:
        draft.isSavingAnnotation = true;
        break;
      case SAVE_SUMMARY_ANNOTATION_SUCCESS:
        draft.isSavingAnnotation = false;
        break;
      case SAVE_SUMMARY_ANNOTATION_FAILURE:
        draft.isSavingAnnotation = false;
        break;

      default:
        return state;
    }
  });

export default ResidentSummaryReducer;
